/**
 * Tool Test Page (Company App Wrapper)
 *
 * @quebon/shared-learning의 ToolTestPage 공통 컴포넌트를 사용.
 * Company 앱의 i18n을 주입.
 */
import { useTranslation } from 'react-i18next'
import { ToolTestPage as SharedToolTestPage } from '@quebon/shared-learning'

export default function ToolTestPage() {
  const { t } = useTranslation('learner')

  return <SharedToolTestPage t={t} />
}
